import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Services } from '@/services/services';

import './Main.css'
import { Translates } from '@/services/repository/i18n';
import { MainPageLayout } from '@/components/layout/MainLayout';
import { MachinePath } from '../../Common';
import { Machine } from '@/services/model/machine';
import { CurrentSession } from '@/services/repository/session';
import { WizardData, LoadWizardData, SaveWizardData } from './Model';
import { BackButton } from '@/components/layout/NavBar';
import { FilesProvider, SimpleFiles } from '@/components/forms/common/files/files';
import { Stream } from '@/services/common/stream';
import * as osfiles from "../../../../../components/forms/common/osfiles"

const API_BASE = "/api/public/tmp/files"

export const MachineFilesWizardStep1 = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const navigate = useNavigate()
  const machineId = useParams().machineid
  const [translates, setTranslates] = useState<Translates>()
  const [machine, setMachine] = useState<Machine>()
  const [wizardData, setWizardData] = useState<WizardData>()
  const statusStreamRef = useRef<Stream<osfiles.UploadStatus>>(new Stream<osfiles.UploadStatus>())

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  useEffect(() => {
    fetch(`/api/communal/machines/byid/${machineId}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMachine(data)
    })
  }, [machineId])

  useEffect(() => {
    if (machineId === undefined) {
      return
    }
    setWizardData(LoadWizardData(machineId))
  }, [machineId])

  if (translates === undefined || machine === undefined || translates === undefined || wizardData === undefined || machineId === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='machine-files-wizard' services={services} translates={translates} session={session} path={MachinePath({ session, translates, machine })}
    navbarLeft={<BackButton services={services} translates={translates} replaceUrl={`/communal/machine/${machineId}`} />}>

    <h2 className='page-title'>{translates.for(`wizards.machine_files.title`)}</h2>

    <FilesProvider insertUrl={`${API_BASE}/new`} updateUrl={`${API_BASE}/{id}/upload`} fetchUrl={`${API_BASE}/{id}/list`} removeUrl={`${API_BASE}/{id}/remove/{fid}`} token={session?.token} translates={translates} filesId={wizardData.setId} statusStream={statusStreamRef.current}
      onChange={(id: string) => setWizardData((prev) => {
        if (!prev) return prev;
        const updated: WizardData = { ...prev, setId: id }
        SaveWizardData(machineId, updated)
        return updated
      })}>
      <SimpleFiles />
    </FilesProvider>

    <div className='approve-btn' onClick={() => {
      SaveWizardData(machineId, wizardData)
      navigate(`/communal/machine/${machineId}/files/upload/page2`, { replace: true })
    }}>
      {translates.for(`wizards.machine_files.next`)}
    </div>

  </MainPageLayout>
}
